@if (!isDiscussionContent) {
  <h3 class="small h6">FACULTY LATEST REPLIES</h3>
}

@if (loadingData) {
  <ebs-spinner [spinnerMessage]="''" [faColour]="'#fff'" [boxColour]="'#fff'"
  [boxPadding]="'5px 15px'" [faFont]="'2.2rem'"></ebs-spinner>
}

@if (postAndReplySearchResults && !loadingData) {
  <ul class="list-group mb-3">
    @for (activity of postAndReplySearchResults; track activity) {
      <li href="#"
        class="list-group-item list-group-item-action flex-column align-items-start"
        [ngClass]="{'snapshot-text': isDiscussionContent}">
        @if (activity) {
          <ebs-reply [truncateContentLength]="truncateContentLength" [isDiscussionContent]="isDiscussionContent"
          [courseCode]="courseCode" [activity]="activity" [isFaculty]="isFaculty"></ebs-reply>
        }
      </li>
    }
  </ul>
}